export enum HomeworkType {
  NotSelected,
  Common,
  WithTeamsAssignment,
  AsTeamsAssignment,
}

export interface BaseTeamsAssignmentData {
  id: string;
  name: string;
}
